import { Bot } from 'lucide-react';
import { memo } from 'react';
import styles from '../agent.module.css';

const AddressConfirmation = memo(function AddressConfirmation({
  address,
  isValid,
  onConfirm,
  onNavigate,
}) {
  return (
    <div className={styles.message}>
      <div className={styles['message__content']}>
        <div className={styles.avatar}>
          <Bot size={24} style={{ color: 'white' }} />
        </div>
        <div
          className={styles['message__bubble']}
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '1rem',
          }}
        >
          {isValid ? (
            <>
              <p>
                Are you trying to search this address?{' '}
                <strong>{address}</strong>
              </p>
              <button
                onClick={onConfirm}
                style={{
                  backgroundColor: '#000',
                  color: 'white',
                  padding: '0.5rem 1rem',
                  borderRadius: '0.5rem',
                  border: 'none',
                  cursor: 'pointer',
                  alignSelf: 'flex-start',
                }}
              >
                Search address
              </button>
            </>
          ) : (
            <>
              <p>
                Are you trying to search a new address?{' '}
                <strong>{address}</strong>
              </p>
              <button
                onClick={onNavigate}
                style={{
                  backgroundColor: '#000',
                  color: 'white',
                  padding: '0.5rem 1rem',
                  borderRadius: '0.5rem',
                  border: 'none',
                  cursor: 'pointer',
                  alignSelf: 'flex-start',
                }}
              >
                Try new address
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
});

export default AddressConfirmation;
